import { PortableText } from '@portabletext/react';
import React, { useState } from 'react';
import { Button, Col, Collapse, Row } from 'react-bootstrap';
import './FaqItem.scss';

function FaqItem({ title, description }) {
  const [open, setOpen] = useState(false);
  const id = ['collapse-text', Math.floor(Math.random() * 100) + 1].join('-');

  return (
    <div className="faqItem">
      <Button variant="link" onClick={() => setOpen(!open)} aria-controls={id} aria-expanded={open} className="button my-3 px-2 py-2">
        <Row className="flex-nowrap" noGutters>
          <Col xs={11}>
            <h3 className="h6 font-weight-bold text-transform-none mb-0 text-white">{title}</h3>
          </Col>
          <Col xs={1} className="d-flex justify-content-end align-items-center ml-auto flex-row">
            <div className="icon">
              <span />
              <span />
            </div>
          </Col>
        </Row>
      </Button>
      <Collapse in={open}>
        <div id={id}>
          <div className="d-flex px-5">
            <div className="divider mb-5 pb-2 pt-4 text-gray-500">
              <PortableText value={description} />
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default FaqItem;
